// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__UJJpK","label":"Category_label__3vuNt","content":"Category_content__1zsvv","header":"Category_header__37QVS","location":"Category_location__3lJcN"};